import React from 'react';

import { cellFactory, Table } from '@components/Table/Table';
import { routePlanServiceNameStrings, routePlanStrings } from '@data/routePlan';
import { RoutePlan } from '@models/RoutePlan';
import { useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';
import { url } from '@utils/pages';
import { Link } from 'react-router-dom';

const strings = createStrings({
  ja: {
    service: ' サービス',
    route: 'ルート',
    fixedDays: '固定日数',
    details: '詳細',
  },
});

interface RoutePlanTableProps {
  routePlans: RoutePlan[];
  editable?: boolean;
}

export const RoutePlanTable: React.FC<RoutePlanTableProps> = (props) => {
  const { routePlans, editable } = props;
  const classes = useCommonStyles();

  return (
    <Table>
      <Table.Head>
        <Table.Row
          columns={[
            cellFactory.create(strings.service),
            cellFactory.create(strings.route),
            cellFactory.create(routePlanStrings.receivingWarehouse),
            cellFactory.create(routePlanStrings.exportWarehouse),
            cellFactory.create('POL'),
            cellFactory.create('POD'),
            cellFactory.createBlank(),
          ]}
        />
      </Table.Head>
      <Table.Body>
        {routePlans?.map((item) => (
          <Table.Row
            disabled={item.disabled}
            key={item.id}
            columns={[
              cellFactory.create(routePlanServiceNameStrings[item.service_name]),
              cellFactory.create(item.name),
              cellFactory.create(
                <>
                  {item.receiving_warehouses.map((r, i) => (
                    <>
                      {r.name}
                      {i < item.receiving_warehouses.length - 1 &&
                        (r.name.length >= 10 ? <br /> : '/')}
                    </>
                  ))}
                </>,
              ),
              cellFactory.create(item.export_warehouse?.name),
              cellFactory.create(item.pol),
              cellFactory.create(item.pod),
              cellFactory.create(
                editable ? (
                  <Link
                    className={classes.link}
                    to={`${url('/admin/widgets/RoutePlanDetail')}?id=${item.id}`}
                  >
                    {strings.details}
                  </Link>
                ) : null,
              ),
            ]}
          />
        ))}
      </Table.Body>
    </Table>
  );
};
